import { render, staticRenderFns } from "./total-report.vue?vue&type=template&id=6fd17ac0&scoped=true"
import script from "./total-report.ts?vue&type=script&lang=ts&external"
export * from "./total-report.ts?vue&type=script&lang=ts&external"
import style0 from "./total-report.less?vue&type=style&index=0&id=6fd17ac0&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd17ac0",
  null
  
)

export default component.exports